import { useState } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Page } from '@frontend/page';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { VoicemailPage } from '../components/voicemails/voicemails-multi.component';

export const Voicemails = () => {
  const { t } = useTranslation('calls', { keyPrefix: 'voicemails' });
  const [selectedTimeRange, setSelectedTimeRange] = useState<string>('');

  return (
    <Page css={styles}>
      <Page.Header>
        <Page.Header.Title title={t('Voicemails')} />
        <Page.Header.Subtitle
          subtitle={!!selectedTimeRange && t(`Showing results for {{timerange}}.`, { timerange: selectedTimeRange })}
        />
      </Page.Header>
      <Page.Body>
        <VoicemailPage setSelectedTimerange={setSelectedTimeRange} />
      </Page.Body>
    </Page>
  );
};

const styles = css`
  max-width: 100%;
  overflow: auto;
  height: 100%;

  @container (max-width: ${breakpoints.xsmall.max}px) {
    padding: 0;

    .page-header {
      padding: ${theme.spacing(2, 2, 0, 2)};
      margin: 0;
    }
  }
`;
